export enum HelpdeskAccessRulesKeyEnum {
  // --- Модуль HELPDESK ---
  // --- Раздел HELPDESK.SECTIONS.HELPDESK ---

  // Вкладки
  HELPDESK_HELPDESK_TASK_READ = 'HELPDESK_HELPDESK_TASK_READ',
  HELPDESK_HELPDESK_TASK_WRITE = 'HELPDESK_HELPDESK_TASK_WRITE',

  HELPDESK_HELPDESK_TASK_TYPE_READ = 'HELPDESK_HELPDESK_TASK_TYPE_READ',
  HELPDESK_HELPDESK_TASK_TYPE_WRITE = 'HELPDESK_HELPDESK_TASK_TYPE_WRITE',

  HELPDESK_HELPDESK_TEMPLATE_READ = 'HELPDESK_HELPDESK_TEMPLATE_READ',
  HELPDESK_HELPDESK_TEMPLATE_WRITE = 'HELPDESK_HELPDESK_TEMPLATE_WRITE',

  HELPDESK_HELPDESK_EMAIL_SETTINGS_READ = 'HELPDESK_HELPDESK_EMAIL_SETTINGS_READ',
  HELPDESK_HELPDESK_EMAIL_SETTINGS_WRITE = 'HELPDESK_HELPDESK_EMAIL_SETTINGS_WRITE',

  HELPDESK_HELPDESK_FIELDS_SETTINGS_READ = 'HELPDESK_HELPDESK_FIELDS_SETTINGS_READ',
  HELPDESK_HELPDESK_FIELDS_SETTINGS_WRITE = 'HELPDESK_HELPDESK_FIELDS_SETTINGS_WRITE',

  HELPDESK_HELPDESK_EAV_ENTITY_TYPE_READ = 'HELPDESK_HELPDESK_EAV_ENTITY_TYPE_READ',
  HELPDESK_HELPDESK_EAV_ENTITY_TYPE_WRITE = 'HELPDESK_HELPDESK_EAV_ENTITY_TYPE_WRITE',

  // Разрешения
  HELPDESK_HELPDESK_READ_ALL_TASKS = 'HELPDESK_HELPDESK_READ_ALL_TASKS',
  HELPDESK_HELPDESK_EDIT_OTHER_USERS_TASKS = 'HELPDESK_HELPDESK_EDIT_OTHER_USERS_TASKS',
  HELPDESK_HELPDESK_DELETE_TASKS = 'HELPDESK_HELPDESK_DELETE_TASKS',
  HELPDESK_HELPDESK_DELETE_OTHER_USER_COMMENTS = 'HELPDESK_HELPDESK_DELETE_OTHER_USER_COMMENTS',
  HELPDESK_HELPDESK_ANSWER_WITH_AI = 'HELPDESK_HELPDESK_ANSWER_WITH_AI',
  HELPDESK_HELPDESK_DETERMINE_BEST_ANSWER = 'HELPDESK_HELPDESK_DETERMINE_BEST_ANSWER',
  HELPDESK_HELPDESK_MERGE_HD_TASKS = 'HELPDESK_HELPDESK_MERGE_HD_TASKS',
}
